import { render } from "./CrudSelectCar.vue?vue&type=template&id=2dc21445"
import script from "./CrudSelectCar.vue?vue&type=script&lang=js"
export * from "./CrudSelectCar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__